import React from 'react';
import { Form } from '@ant-design/compatible';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import Panel from '../../../components/Panel';
import Input from '../../../components/input/Input';
import Button from '../../../components/Button';
import { useRequestDownloadLuckyDrawParticipants } from '../../../hooks/queries/luckyDraw/useRequestDownloadLuckyDrawParticipants';
import useToastMsg from '../../../hooks/common/useToastMsg';
import { asyncSimpleModal } from '../../../lib/common';

const DownloadLuckyDrawParticipants = (props: FormComponentProps) => {
  const { form } = props;
  const { getFieldDecorator } = form;

  const { error } = useToastMsg();
  const { mutate, isLoading } = useRequestDownloadLuckyDrawParticipants();

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        mutate(values.code, {
          onSuccess: async () => {
            await asyncSimpleModal({
              type: 'success',
              title: '엑셀 파일 요청 완료',
              message: `엑셀 파일이 생성되면 #amondz_admin_excel 슬랙 채널을 통해 다운로드 링크가 담긴 메시지가 전송됩니다 슬랙을 확인해주세요`,
            });
          },
          onError: () => {
            error('다운로드에 실패했습니다.');
          },
        });
      }
    });
  };

  return (
    <Panel>
      <Form layout="vertical" onSubmit={handleSubmit}>
        <Form.Item label="응모코드">
          {getFieldDecorator('code', {
            rules: [{ required: true, message: '응모코드를 입력해주세요' }],
          })(<Input placeholder="p1234" disabled={isLoading} />)}
        </Form.Item>
        <Form.Item>
          <Button type="submit" text="다운로드" color="primary" disabled={isLoading} />
        </Form.Item>
      </Form>
    </Panel>
  );
};

export default Form.create()(DownloadLuckyDrawParticipants);
